import React, { useEffect, useState } from "react";
import { AiOutlineRight } from "react-icons/ai";
import { ArrowLeftOutlined } from "@ant-design/icons";
import {
  Input,
  Space,
  Form,
  Button,
  Modal,
  notification,
  Checkbox,
  Row,
  Col,
  Table,
} from "antd";
import {
  components,
  GetLoggedInUser,
  getRowClassName,
} from "../../../utils/utils";
import { useNavigate, useParams } from "react-router-dom";
import RoleRequest from "../RoleRequest";
import { usePermission } from "../../../hooks/usePermission";

export const AddRole = () => {
  const navigate = useNavigate();
  const [moduleData, setModuleData] = useState();
  const permission = usePermission("Roles", "Add");
  console.log(permission, "permissoon");
  let LOG_IN_USER = GetLoggedInUser();

  const [selectedCheckboxes, setSelectedCheckboxes] = useState({
    Users: "",
    Roles: "",
    Staff: "",
    Category: "",
    Salon: "",
    Appointment: "",
  });
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { TextArea } = Input;

  const onFinish = (values) => {
    console.log(values);
    setLoading(true);
    const allFormData = { ...values, permissions: selectedCheckboxes };
    console.log("Submitting data to API:", allFormData);
    RoleRequest.createRole(allFormData)
      .then((res) => {
        console.log("API Response:", res);
        if (res.status === 201) {
          notification.success({
            message: "Role added successfully",
          });
          navigate(-1);
        } else {
          notification.error({
            message: "Something went wrong",
          });
        }
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        notification.error({
          message: "Failed to add category",
        });
        console.error("API Error:", e);
      });
  };

  useEffect(() => {
    const getModuleDetails = async () => {
      setLoading(true);

      try {
        const res = await RoleRequest.getModule(); // Fetch role details
        const roleData = res?.data?.data?.ModuleName;
        console.log("Role Data:", roleData);
        if (roleData) {
          setModuleData(roleData);
        }
      } catch (e) {
        console.log("Error fetching role details:", e);
      } finally {
        setLoading(false);
      }
    };

    getModuleDetails();
  }, []);

  const columns = (selectedCheckboxes, setSelectedCheckboxes) => [
    {
      title: "Module Name",
      dataIndex: "moduleName",
      key: "moduleName",
      width: 400,
    },
    {
      title: "View",
      dataIndex: "view",
      key: "view",
      width: 160,
      render: (_, record) => (
        <Checkbox
          checked={selectedCheckboxes[record.moduleName] === 1}
          onChange={() =>
            handleCheckboxChange(record.moduleName, 1, setSelectedCheckboxes)
          }
        />
      ),
    },
    {
      title: "View | Add",
      dataIndex: "viewAdd",
      key: "viewAdd",
      render: (_, record) => (
        <Checkbox
          checked={selectedCheckboxes[record.moduleName] === 2}
          onChange={() =>
            handleCheckboxChange(record.moduleName, 2, setSelectedCheckboxes)
          }
        />
      ),
    },
    {
      title: "View | Edit",
      dataIndex: "viewEdit",
      key: "viewEdit",
      render: (_, record) => (
        <Checkbox
          checked={selectedCheckboxes[record.moduleName] === 3}
          onChange={() =>
            handleCheckboxChange(record.moduleName, 3, setSelectedCheckboxes)
          }
        />
      ),
    },
    {
      title: "View | Edit | Add",
      dataIndex: "viewEditAdd",
      key: "viewEditAdd",
      width: 180,
      render: (_, record) => (
        <Checkbox
          checked={selectedCheckboxes[record.moduleName] === 4}
          onChange={() =>
            handleCheckboxChange(record.moduleName, 4, setSelectedCheckboxes)
          }
        />
      ),
    },
    {
      title: "View | Edit | Add | Delete",
      dataIndex: "viewEditAddDelete",
      key: "viewEditAddDelete",
      width: 200,
      render: (_, record) => (
        <Checkbox
          checked={selectedCheckboxes[record.moduleName] === 5}
          onChange={() =>
            handleCheckboxChange(record.moduleName, 5, setSelectedCheckboxes)
          }
        />
      ),
    },
  ];

  const handleChange = (value) => {
    console.log(`selected ${value}`);
  };

  const handleSubmit = () => {
    form.submit();
  };

  const handleCheckboxChange = (
    moduleName,
    selectedValue,
    setSelectedCheckboxes
  ) => {
    setSelectedCheckboxes((prevState) => ({
      ...prevState,
      [moduleName]: selectedValue,
    }));
  };

  return (
    <section>
      <div className="Create-Category">
        <Form.Item className="text-center test submit-btn">
          <Space>
            <Button
              className="f-sub-btn btn-width"
              onClick={() => navigate(-1)}
              disabled={loading}
            >
              <ArrowLeftOutlined />
            </Button>
          </Space>
        </Form.Item>
        <h3>Role Add</h3>

        <Form
          form={form}
          layout="vertical"
          initialValues={null}
          onFinish={onFinish}
        >
          {/* First Row */}
          <div className="subscription">
            <Form.Item
              name="roleTitle"
              label="Title"
              className="subscription-plan"
              rules={[
                { required: true, message: "Please enter the title!" },
                {
                  min: 3,
                  message: "Title must be at least 3 characters long!",
                },
                { max: 50, message: "Title cannot exceed 50 characters!" },
              ]}
            >
              <Input size="large" placeholder="Enter Title" />
            </Form.Item>

            <Form.Item
              name="additionalInfo"
              label="Additional Field"
              className="subscription-plan"
              rules={[
                { required: true, message: "Please enter the text!" },
                { min: 3, message: "Text must be at least 3 characters long!" },
                { max: 50, message: "Text cannot exceed 50 characters!" },
              ]}
            >
              <Input size="large" placeholder="Enter Title" />
            </Form.Item>
          </div>
          <h3>Select Permissions</h3>

          <div style={{ marginTop: "20px" }}>
            <Table
              size="middle"
              bordered
              rowClassName={getRowClassName}
              components={components}
              columns={columns(selectedCheckboxes, setSelectedCheckboxes)}
              loading={loading}
              dataSource={moduleData}
              pagination={false}
              rowKey="id"
            />
          </div>

          <div className="bottom-button">
            <div style={{ padding: "10px" }}>
              <Button type="primary" htmlType="submit" loading={loading}>
                Save & Proceed
                <span>
                  <AiOutlineRight />
                </span>
              </Button>
            </div>
          </div>
        </Form>
      </div>
    </section>
  );
};
